export const CHANGE_SIDEBAR = "CHANGE_TOGGLE_SIDEBAR";
